import { api } from "../api";
import { ISingIn } from "../interfaces/usuarios";
import { IPaymentsResponse } from "../interfaces/payments";

export class PaymentService {

  async getList(): Promise<IPaymentsResponse> {
    return api.get<IPaymentsResponse>('/payments')
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  async signIn(payload: any): Promise<ISingIn> {
    return api.post<ISingIn>('/payments', payload)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  async signUp(payload: any): Promise<ISingIn> {
    return api.post<ISingIn>('/usuarios', payload)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }
}
